import { Routes } from '@angular/router';
import { storyblokPreventNavInEditModeGuard } from '../storyblok-prevent-nav-in-edit-mode.guard';
import { storyblokStoryGuard } from '../storyblok-story.guard';
import { storyblokBackendPricesResolver } from './storyblok-backend-prices.resolver';
import { StoryblokPageComponent } from './storyblok-page/storyblok-page.component';
import { storyblokPromotionResolver } from './storyblok-promotion.resolver';
import { storyblokRelationshipsResolver } from './storyblok-relationships.resolver';
import { storyblokStoryResolver } from './storyblok-story.resolver';
import { storyblokToolsConvertFromFormatsResolver } from './storyblok-tools-convert-from-formats.resolver';

export const routes: Routes = [
  {
    path: '**',
    component: StoryblokPageComponent,
    canActivate: [storyblokStoryGuard],
    canDeactivate: [storyblokPreventNavInEditModeGuard],
    resolve: {
      story: storyblokStoryResolver,
      backendPrices: storyblokBackendPricesResolver,
      promotion: storyblokPromotionResolver,
      relationships: storyblokRelationshipsResolver,
      toolConversionFromFormatList: storyblokToolsConvertFromFormatsResolver,
    },
  },
];
